import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BarI18nPipe } from '../../i18n/bar-i18n.pipe';
import { BaasRemarkList } from '../baas-remark-list/baas-remark-list';
import { BaasRemarkOptions } from '../baas-remark-options.type';
import { BaasRemarkSummary } from '../baas-remark-summary/baas-remark-summary';

@Component({
    selector: 'baas-remark-overview',
    templateUrl: './baas-remark-overview.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasRemarkSummary, BaasRemarkList, BarI18nPipe]
})
/** Represents a remark overview  */
export class BaasRemarkOverview {
    readonly remarks = input.required<BaasRemarkOptions[]>();
}
